define([
    'backbone',
    'handlebars',
    'modules/common/controls/control'
], (Backbone, Handlebars, Control) => Control.extend({

    binders: {
        value: {
            bind (view, publish) {
                this.callback = function () {
                    publish(view.get());
                };
                view.on('change', this.callback);
            },
            unbind (view) {
                view.off('change', this.callback);
            },
            routine (view, value) {
                view.set(value);
            }
        },
        enabled (view, value) {
            view.setEnabled(Boolean(value));
        },
        toggle (view, value) {
            view.$el.toggle(Boolean(value));
        }
    },

    events: {
        'change input': 'checkboxChange'
    },

    defaults: _.extend({
        id: 'id',
        text: 'text',
        coerceNumber: false
    }, Control.prototype.defaults),

    initialize () {
        Control.prototype.initialize.apply(this, arguments);
        this.choices = this.options.choices;
    },

    render () {
        const items = this.choices instanceof Backbone.Collection ? this.choices.toJSON() : this.choices;
        const self = this;

        this.$el.empty().append(items.map((item) => $('<label>').
            addClass('checkbox').
            toggleClass('inline', Boolean(self.options.inline)).
            append($('<input>').attr({type: 'checkbox', value: item[self.options.id]})).
            append(self.formatLabel(item))));

        return this;
    },

    formatLabel (item) {
        return item[this.options.text];
    },

    get () {
        const coerceNumber = this.options.coerceNumber;
        return this.$('input:checked').map(function () {
            return coerceNumber ? Number($(this).val()) : $(this).val();
        }).
            get();
    },

    set (ids) {
        ids = ids.map((id) => id.toString());
        this.$('input').each(function () {
            $(this).prop('checked', _.contains(ids, $(this).val()));
        });
    },

    setEnabled (enabled) {
        this.$('input').attr('disabled', !enabled);
    },

    checkboxChange () {
        this.trigger('change');
    }
}));
